import { useEffect } from 'react'
import { useBucket } from '@mc/experiments-react'
import { type InstructorQuote } from '@mc/growth-data'
import { useStaticData } from '@mc/static-data-react'
import { trackExperimentViewed } from '@mc/track-event'
import { PEN_7315_V1_CM_INSTRUCTOR_QUOTE_FLAG } from './constants'

interface InstructorQuoteExperiment {
  quote: InstructorQuote | null
  isVariant: boolean
}

export const useInstructorQuoteExperiment = (): InstructorQuoteExperiment => {
  const { instructorQuote: quote = null } = useStaticData<{
    instructorQuote?: InstructorQuote | null
  }>()
  const bucket = useBucket(PEN_7315_V1_CM_INSTRUCTOR_QUOTE_FLAG)

  const isInScope = quote !== null

  useEffect(() => {
    if (isInScope && bucket) {
      trackExperimentViewed(PEN_7315_V1_CM_INSTRUCTOR_QUOTE_FLAG)
    }
  }, [isInScope, bucket])

  return {
    quote,
    isVariant: bucket === 'variant_1',
  }
}
